import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_user',
};

export const getProfile = () =>
  createRequest({
    url: config.url,
    method: config.method,
  });
